// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"664ab0c1","433":"8b78e4e9","796":"52f6974f","822":"c7e28379","990":"58eb8eba"}[chunkId] + ".chunk.js";
};